import paymentAPI from "@/app/apis/main/payment/payment-api.js"

export default {
	/**
	 * @return {object} order
	 * @params orderId
	 * */
	async putPaymentStatus(orderId) {
		return paymentAPI.putPaymentStatus(orderId)
	},

	/**
	 * @return {object} payment details
	 * @params details { token, referenceNumber }
	 * */
	async processPendingPayment(details) {
		return paymentAPI.processPendingPayment(details)
	},

	/**
	 * @return
	 * @params dogPurchaseId, dogPurchasePaymentId
	 * */
	async dogPurchaseManualProcessPendingPayment(dogPurchaseId, dogPurchasePaymentId, status) {
		return paymentAPI.dogPurchaseManualProcessPendingPayment(dogPurchaseId, dogPurchasePaymentId, status);
	},

	/**
	 * @return
	 * @params puppySellId, puppySellPurchaseId
	 * */
	async puppyPurchaseManualProcessPendingPayment(puppySellId, puppySellPurchaseId, status) {
		return paymentAPI.puppyPurchaseManualProcessPendingPayment(puppySellId, puppySellPurchaseId, status);
	},
}
